import { BaseModel } from './base/base.model';

export class A3LEmployee extends BaseModel {
  employeeCode: string;
  identifierNumber: string;
  completeName: string;
  dropDate: Date;
  workplaceCode: number;
  lastUpdate: string;
}
